import { GRADE_OPTIONS } from '../constants/grades';
import { FiTrash2 } from 'react-icons/fi';

export default function CourseRow({ course, index, onChange, onRemove, disableRemove = false }) {
  return (
    <div className="grid grid-cols-12 items-center gap-2 border-b border-brand-border py-2">
      <label className="col-span-4 text-sm">
        <input
          type="text"
          value={course.name}
          placeholder={`Course ${index + 1}`}
          onChange={(event) => onChange(index, 'name', event.target.value)}
          className="elevated w-full rounded-xl border border-brand-border bg-brand-surface px-3 py-2 text-center text-brand-text"
        />
      </label>
      <label className="col-span-3 text-sm">
        <select
          value={course.grade}
          onChange={(event) => onChange(index, 'grade', event.target.value)}
          className="elevated w-full rounded-xl border border-brand-border bg-brand-surface px-3 py-2 text-center text-brand-text"
        >
          {GRADE_OPTIONS.map((option) => <option key={option} value={option}>{option}</option>)}
        </select>
      </label>
      <label className="col-span-4 text-sm">
        <input
          type="number"
          min="0.5"
          max="50"
          step="0.5"
          value={course.credits}
          onChange={(event) => onChange(index, 'credits', event.target.value)}
          className="elevated w-full rounded-xl border border-brand-border bg-brand-surface px-3 py-2 text-center text-brand-text"
        />
      </label>
      <div className="col-span-1 flex items-end justify-end">
        <button
          type="button"
          onClick={() => onRemove(index)}
          className="inline-flex items-center justify-center rounded-xl p-2 text-brand-muted hover:text-brand-dangerText disabled:cursor-not-allowed disabled:opacity-40"
          disabled={disableRemove}
          aria-label={`Delete course row ${index + 1}`}
          title="Delete row"
        >
          <FiTrash2 size={16} />
        </button>
      </div>
    </div>
  );
}
